/**
 * Top-of-page popup for the 4-concurrent-generations limit. Mounted
 * once in AppLayout; any page (or the AI chat) triggers it via
 * showGenerationLimitToast(). Auto-dismisses after 8 seconds.
 */
import React, { useEffect, useRef, useState } from 'react';
import { GENERATION_LIMIT_EVENT, GENERATION_LIMIT_MESSAGE } from '../utils/generationLimit';

export default function GenerationLimitToast() {
  const [visible, setVisible] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    const onLimit = () => {
      setVisible(true);
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => setVisible(false), 8000);
    };
    window.addEventListener(GENERATION_LIMIT_EVENT, onLimit);
    return () => {
      window.removeEventListener(GENERATION_LIMIT_EVENT, onLimit);
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  if (!visible) return null;

  return (
    <div
      role="alert"
      style={{
        position: 'fixed',
        top: 18,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 10500,
        maxWidth: 520,
        width: 'calc(100% - 32px)',
        background: 'white',
        border: '1px solid #e4e0f7',
        borderRadius: 14,
        boxShadow: '0 12px 34px rgba(30, 20, 80, 0.18)',
        padding: '14px 16px',
        display: 'flex',
        alignItems: 'flex-start',
        gap: 12,
        animation: 'au-toast-in 0.25s ease',
      }}
    >
      <div
        style={{
          width: 34,
          height: 34,
          flexShrink: 0,
          borderRadius: 10,
          background: 'linear-gradient(135deg, #6B4EE8 0%, #4A90E2 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 17,
        }}
      >
        ⏳
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontWeight: 700, fontSize: 13.5, color: '#1a1a2e', marginBottom: 2 }}>
          Generation limit reached
        </div>
        <div style={{ fontSize: 13, color: '#444', lineHeight: 1.45 }}>
          {GENERATION_LIMIT_MESSAGE}
        </div>
      </div>
      <button
        type="button"
        aria-label="Dismiss"
        onClick={() => setVisible(false)}
        style={{
          border: 'none',
          background: 'transparent',
          cursor: 'pointer',
          fontSize: 16,
          lineHeight: 1,
          color: '#8a8a9a',
          padding: 2,
        }}
      >
        ×
      </button>
    </div>
  );
}
